/**
 * Shared Tailwind class constants for the reference section library.
 *
 * Keeping these in one place avoids re-typing the gradient-clip and code
 * syntax colors across sections. Every pink here now comes from the one brand ramp: the gradient runs
 * brand-800 -> brand-600 -> brand-500, where 500 is the logo colour itself.
 */

/** JetBrains Mono — the reference monospace face. */
export const MONO = "font-jetbrains";

/** Gradient title text — the reference `.grad` (brand-800 → brand-600 → brand-500). */
export const GRAD_TEXT =
  "bg-clip-text text-transparent [background-image:linear-gradient(100deg,var(--color-brand-800),var(--color-brand-600)_55%,var(--color-brand-500))]";

/** Syntax-highlight colors for dark code blocks (terminal / JSON panes). */
export const CODE = {
  comment: "text-[#7a7a88]",
  key: "text-[#ff7eae]",
  string: "text-[#84d68c]",
  number: "text-[#7fb0ff]",
  bool: "text-[#f0c451]",
} as const;
